import script from "./Alert.vue?vue&type=script&lang=ts&setup=true"
export * from "./Alert.vue?vue&type=script&lang=ts&setup=true"

import "./Alert.vue?vue&type=style&index=0&id=60d2c9b9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d2c9b9"]])

export default __exports__